import { useAppSelector } from "@configs/Redux";

export default function useUserPermissions() {
  const { userPermissions } = useAppSelector((state) => state.system);

  const isUserDashboardEditable = () => {
    return (
      userPermissions.dashboard.dashboardAddEditDelete &&
      userPermissions.dashboard.widgetAddDeleteShowHide
    );
  };

  const isUserAccessibleAnalytics = () => {
    return userPermissions.analytics.search;
  };

  const isUserAccessibleReport = () => {
    return userPermissions.report.reportView;
  };

  const isUserAccessibleInsight = () => {
    return userPermissions.analytics.insight;
  };
  const isUserAccessibleSettings = () => {
    return (
      userPermissions.setting.userManagement &&
      userPermissions.setting.deviceManagement
    );
  };

  const isUserDashboardSequenceEnabled = () => {
    return userPermissions.dashboard.dashboardSequence;
  };

  return {
    isUserDashboardEditable,
    isUserAccessibleAnalytics,
    isUserAccessibleReport,
    isUserAccessibleInsight,
    isUserAccessibleSettings,
    isUserDashboardSequenceEnabled
  };
}
